<template>
    <div>
        <van-tabs v-model="tabIndex" :sticky="true">
            <van-tab v-for="(tabItem, tabIndex) in tabList" :title="tabItem.title" :key="tabIndex">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-empty v-if="exchangeList.length <= 0" description="暂无数据" />
                    <van-list v-else :finished="finished" :error.sync="error" finished-text="没有更多了" @load="onLoad">
                        <div class="exchange-item" v-for="(exchangeItem, exchangeIndex) in exchangeList" :key="exchangeIndex" @click="$router.push({ name : 'ExchangeDetail', query : { id : exchangeItem.id } })">
                            <van-row type="flex" justify="space-between" align="center">
                                <van-col :span="16">
                                    <van-card :thumb="(exchangeItem.detail.goods && exchangeItem.detail.goods.image) || icon_img.car_wash" style="background-color: #ffffff;" :title="$store.state.systemEnum['company']['user_exchange']['type'][exchangeItem.type]">
                                        <template #desc>
                                            <span class="exchange-item-desc">{{getItemTitle(exchangeItem)}}</span>
                                        </template>
                                    </van-card>
                                </van-col>
                                <van-col :span="8" style="text-align: center;">
                                    <van-button plain round type="danger" size="small" class="exchange-item-button">{{exchangeItem.status === '0' ? '去兑换' : '去查看'}}</van-button>
                                </van-col>
                            </van-row>
                            <!--<van-card :num="exchangeItem.detail.goods.buy_number" :thumb="exchangeItem.detail.goods.image" style="background-color: #ffffff;">
                                <template #title>
                                    <div style="font-size: 18px;">{{exchangeItem.detail.goods.title}}</div>
                                </template>
                            </van-card>-->
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: "Index",
        data(){
            return {
                tabList : [
                    {
                        title : '待核销',
                        status : '0',
                    },
                    {
                        title : '已核销',
                        status : '1',
                    },
                    {
                        title : '已过期',
                        status : '2',
                    },
                ],
                tabIndex : 0,
                loading: false,
                finished: false,
                refreshing: false,
                error : false,
                params : {
                    page : 1,
                    page_size : 15,
                },
                exchangeList : [],
                icon_img: {
                    car_wash: require('@/assets/carwash_my.png'),
                }
            };
        },
        watch : {
            tabIndex(newValue, oldValue){
                this.onRefresh();
            },
        },
        created() {
            this.onRefresh();
        },
        methods : {
            onLoad(){
                let self = this;
                if(self.loading) return;

                self.loading = true;
                api.request('/exchange/list', Object.assign({}, self.params, {
                    'status' : this.tabList[this.tabIndex]['status'],
                })).then(res => {
                    if(self.params.page >= res.data.max_page){
                        self.finished = true;
                    }else{
                        self.params.page++;
                    }

                    // 如果是刷新就把数据清空
                    if(self.refreshing){
                        self.exchangeList = [];
                    }

                    for(let index in res.data.data){
                        self.exchangeList.push(res.data.data[index]);
                    }
                }).catch(res => {
                    self.error = true;
                }).finally(() => {
                    self.loading = false;
                    self.refreshing = false;
                });
            },
            onRefresh() {
                this.finished = false;
                this.refreshing = true;
                this.params.page = 1;
                this.onLoad();
            },
            getItemTitle(exchange) {
                if (exchange.type === 'custom') {
                    return exchange.exchange && exchange.exchange.template && exchange.exchange.template.name
                } else if (exchange.type === 'goods_exchange') {
                    return '商品兑换券'
                }
                return '兑换券'
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    @import '../../style/themeify.scss';
    *{
        @include themeify{
            /deep/ .van-tabs__line {
                background-color: themed('colorTag');
            }

            /deep/ .van-tab--active {
                color: themed('colorText')
            }

            .exchange-item-button {
                border-color: themed('colorButton');
                color: themed('colorButton');
            }
            
            .exchange-item-desc {
                display: block;
                margin-top: 3px;
                color: themed('colorText');
                font-size: 0.4rem;
                font-weight: bold;
            }
        }
    }
    .exchange-item{
        margin: 10px 15px;
        background-color: #ffffff;
        border-radius: 0.3rem;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/pages/exchange/Index.vue